module.exports = __webpack_public_path__ + "static/media/jupiterTutF.a6c8df72.jpg";